import React from "react";

const TermsConditions = () => {
    return(
        <div className="TermsConditions-section">
            <div className="TermsConditions-content">
                <p className="TermsConditions-product">hi™</p>
                <p className="TermsConditions-heading">END USER LICENSE AGREEMENT</p>
                <p className="TermsConditions-points">
                    1. This web application hi™ (“Application” or “App”) and other related documentation are 
                    licensed by aiRender® Technology Pvt. Ltd. and/or its affiliates (“Company”, “we” or “us”), 
                    having office at aiRender® Technology Pvt. Ltd. H-005, Vijetha Elysium, Hagadur Road, 
                    Whitefield, Bengaluru, Karnataka, India 560066, to be used only by the user (“you / your”) 
                    who access or download or avail the Application in accordance with the terms of this End 
                    User License Agreement (“EULA”).
                </p>
                <p className="TermsConditions-points">
                    2. This EULA is an electronic record under Information Technology Act, 2000 and the rules 
                    thereunder as applicable and as amended time to time pertaining to electronic records 
                    under applicable Indian laws. This electronic record is generated by a computer system and 
                    does not require any physical or digital signatures. This is a binding agreement between 
                    aiRender® Technology Pvt. Ltd (“Company”, “we” or “us”) and you.
                </p>
                <p className="TermsConditions-points TermsConditions-important-point">
                    3. BY DOWNLOADING THIS APPLICATION OR BY CLICKING ON THE “I ACCEPT” BUTTON AND/OR BY USING 
                    THIS APPLICATION, OR OTHERWISE BY HAVING ACCESS TO, RECEIVING, AND/OR BY USING THE 
                    APPLICATION, YOU HEREBY CONFIRM TO HAVE READ, UNDERSTOOD AND AGREE TO BE GOVERNED AND 
                    BOUND BY, THIS EULA, AND THE PRIVACY POLICY WHICH IS INCORPORATED BY REFERANCE AND FORMS 
                    PART OF EULA AND ANY OTHER RULES OR GUIDELINES, AS MAY BE ISSUED BY aiRender® Technology 
                    WITH RESPECT TO THE APPLICATION, FROM TIME TO TIME. YOU MAY ACCESS THE PRIVACY POLICY HERE 
                    BELOW. IF YOU DO NOT AGREE TO BE BOUND BY THE EULA, PLEASE DO NOT CLICK THE “I ACCEPT” 
                    BUTTON OR DOWNLOAD OR INSTALL THE APPLICATION AND USE.
                </p>
                <p className="TermsConditions-points">
                    4. This EULA is deemed to be published and shall be construed in accordance with the 
                    provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 
                    2011 under Information Technology Act, 2000 that require publishing the rules and 
                    regulations, privacy policy and user agreement for access or usage of the Content.
                </p>
                <p className="TermsConditions-points">
                    5. For the purpose of this EULA:
                    <p className="TermsConditions-sub-points-L1">
                        5.1 "Application" means the web application made available to
                        <p className="TermsConditions-sub-points-L2">
                            (i) initiate communication with your contacts; and
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (ii) receive communications from other users of the Application.
                        </p>
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        5.2 "Services" means
                        <p className="TermsConditions-sub-points-L2">
                            (i) provision of Application for initiating and receiving communication with your contacts;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (ii) initiating and receiving audio communication with your contacts;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (iii) HD quality video calling to users of the Application;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (v) access to third party services through their partnered channels;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (vi) and any other services as may be made available from time to time by the Company;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (viii) High quality audio calling to users of the Application;    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (ix) chat platform to users of the Application    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (x) HD quality video recording and high quality audio recording to users of the Application    
                        </p>
                        <p className="TermsConditions-sub-points-L2">
                            (xi) any other features (eg. Video resolution settings) that the company may add from time     
                            to time.
                        </p>
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        5.3 “Content” shall include all visual works, including all interactive content, texts, 
                        photographs, stickers etc., made available to you through the Application from time to 
                        time by the Company. The Content is owned by the Company or by third party content 
                        providers and licensed to the Company. Subject to your strict and full compliance with 
                        the EULA, the Company, hereby grants you a personal, limited, non-exclusive, 
                        non-transferable, revocable license to use the Content for your private and personal 
                        use through your Device.
                    </p>
                </p>
                <p className="TermsConditions-points">
                    6. In order to access the Application, you will be required to
                    <p className="TermsConditions-sub-points-L1">
                        (i) Access the Application on your desktop/laptop supported by Microsoft Windows OS/Linux 
                        OS (variants)/Apple macOS and/or smart phone supported by Google Android/Apple iOS; 
                        through web browsers such as Google Chrome/FireFox by Mozilla/Microsoft Edge or any other 
                        web browser.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        (ii) Download and install the Application on your smart phone supported by Google 
                        Android/Apple iOS; through Google PlayStore or Apple App Store or other app stores 
                        supported by different vendors.
                    </p>
                </p>
                <p className="TermsConditions-points">
                    7. For disclosures relating to the collection and use of your personal information arising 
                    out of the use of this Application, please refer to the privacy policy available below.
                </p>
                <p className="TermsConditions-points">
                    8. Modifications of TandC: The Company reserves the right to change the EULA under which 
                    the Services are offered, including but not limited to the charges, if any, associated 
                    with the use of the Services. This EULA may be further modified based on changes in the 
                    business, legal and regulatory requirements and will be updated online. We will make all 
                    efforts to communicate any significant changes to this EULA to you. You are encouraged to 
                    periodically visit this page to review the EULA and any changes to it.
                </p>
                <p className="TermsConditions-points">
                    9. Modification of Services: The Company reserves the right to add, modify or delete any 
                    content or features available in the Services at any time at its sole discretion.
                </p>
                <p className="TermsConditions-points">
                    10. The Services offered by the Application are intended solely for the purpose of 
                    initiating and receiving video and/or audio communication with your contacts and such 
                    other services mentioned under Services. Unless otherwise specified, the Application is 
                    for your personal and non-commercial use. You may not modify, copy, distribute, transmit, 
                    display, perform, reproduce, publish, license, create derivative works from, transfer, or 
                    sell any information, software, products or Services obtained from the Application.
                </p>
                <p className="TermsConditions-points">
                    11. The Application may contain links to or feeds from other web sites/applications 
                    ("Linked Sites"). The Linked Sites are not under the control of the Company and the 
                    Company is not responsible for the contents of any Linked Site, including without 
                    limitation any link contained in a Linked Site, or any changes or updates to a Linked Site 
                    or any information transmitted on a Linked Site. The inclusion of any link does not imply 
                    endorsement by the Company of the site or any association with its operators.
                </p>
                <p className="TermsConditions-points">
                    12. Any dealings with third parties (including advertisers) included within or available 
                    via a link from the Application or participation in promotions, including the delivery of 
                    and the payment for goods and services, and any other terms, conditions, warranties or 
                    representations associated with such dealings or promotions, are solely between you and 
                    the advertiser or other third party. The Company shall not be responsible or liable for 
                    any part of any such dealings or promotions.
                </p>
                <p className="TermsConditions-points">
                    13. The Application is owned by aiRender® Technology® Technology Pvt. Ltd. or by a 
                    third-party and licensed to the Company. Subject to your strict and full compliance with 
                    the EULA, Company, hereby grants you a personal, limited, non-exclusive, non-transferable, 
                    revocable license to use the Application for your private and personal use. As a condition 
                    of your use of the Application, you warrant to the Company that you will not use the 
                    Application for any purpose that is unlawful or prohibited by this EULA. You may not use 
                    the Application in any manner which could damage, disable, overburden or impair the 
                    Services.
                </p>
                <p className="TermsConditions-points">
                    14. You are not entitled to use any kind of measures, mechanisms or tools (software or 
                    hardware) that could interfere with the functioning of the Application, or any of the 
                    Services thereunder.
                </p>
                <p className="TermsConditions-points TermsConditions-important-point">
                    15. LIABILITY DISCLAIMER
                    <p className="TermsConditions-sub-points-L1">
                        15.1. THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO REPRESENTATIONS ABOUT THE 
                        COMPATIBILITY, SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS AND ACCURACY OF THE 
                        INFORMATION, SOFTWARE AND SERVICES CONTAINED ON THE APPLICATION FOR ANY PURPOSE. ALL SUCH 
                        INFORMATION, SOFTWARE AND SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. 
                        THE COMPANY AND/OR ITS RESPECTIVE SUPPLIERS HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS 
                        WITH REGARD TO THIS INFORMATION, SOFTWARE, AND SERVICES, INCLUDING ALL IMPLIED WARRANTIES 
                        AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND 
                        NON-INFRINGEMENT.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        15.2. YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE RESPONSIBLE FOR UNAUTHORISED 
                        ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA, ANY MATERIAL OR DATA SENT OR 
                        RECEIVED OR NOT SENT OR RECEIVED, OR ANY TRANSACTIONS ENTERED INTO THROUGH THE APPLICATION.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        15.3. YOU SPECIFICALLY AGREE THAT THE COMPANY IS NOT RESPONSIBLE OR LIABLE FOR ANY 
                        INFRINGEMENT OF ANOTHER'S RIGHTS, INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY 
                        AGREE THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT USING AND/OR INCLUDED IN 
                        THE APPLICATION BY ANY THIRD PARTY.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        15.4. THE COMPANY DOES NOT GUARANTEE COMPATIBILITY WITH ALL COMPUTER SYSTEMS, OPERATING 
                        SYSTEMS, SMART PHONES, NETWORKS, INCLUDING ALL VERSIONS OF THEM. THE USE OF THE SMART 
                        PHONE, SITE, AND SOFTWARE, AND AUTOMATIC UPGRADES OF THE SOFTWARE, MAY REQUIRE UPGRADES TO 
                        COMPUTER OR SMART PHONE OPERATING SYSTEMS, NETWORKS, AND APPLICATION SOFTWARE.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        15.5. ANY REQUIREMENTS FOR THE FUNCTIONING OF THE APPLICATION ON YOUR PHONE OR DEVICE, 
                        SUCH AS SUFFICIENT BATTERY BACK UP, INTERNET NETWORK STRENGTH ETC. IS YOUR SOLE 
                        RESPONSIBILITY.
                    </p>
                    <p className="TermsConditions-sub-points-L1">
                        15.6. IN NO EVENT SHALL THE COMPANY AND/OR ITS AFFILIATES BE LIABLE FOR ANY DIRECT, 
                        INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER 
                        INCLUDING, WITHOUT LIMITATION, DAMAGES FOR OR IN RELATION TO THE PROVISION OF OR FAILURE 
                        TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE AND SERVICES OBTAINED THROUGH THE 
                        APPLICATION, OR OTHERWISE ARISING OUT OF THE USE OF, WHETHER BASED ON CONTRACT, TORT, 
                        NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF THE COMPANY OR ANY OF ITS SUPPLIERS HAS 
                        BEEN ADVISED OF THE POSSIBILITY OF DAMAGES.
                    </p>
                </p>
                <p className="TermsConditions-points">
                    16. The Company reserves the right to blacklist, disable and terminate that user from 
                    further using the Application or its Services. If the Company disables access to your 
                    account in accordance with the EULA (for example if you violate any applicable terms), you 
                    may be prevented from accessing the Application, your account details and/or any files 
                    and/or other Services that is stored with your account. The Company reserves the right, at 
                    its sole discretion, to terminate your access to any or all Services of the App and the 
                    related Services or any portion thereof at any time, without notice.
                </p>
                <p className="TermsConditions-points">
                    17. Accuracy of Information: You agree that the information entered by you while profile 
                    creation/updation or using any of Services is true, current, complete and accurate in all 
                    respects. The Company is not responsible for any losses arising out of discrepancy in your 
                    data. You are solely responsible for maintaining confidentiality and security of your user 
                    account and for all activities that occur on or through your user account. The Company is 
                    not responsible for any losses arising out of the unauthorized use of your user account.
                </p>
                <p className="TermsConditions-points">
                    18. Use Restriction: You must not access the Application if you are a person who is either 
                    barred or otherwise legally prohibited from receiving or using the Service or any Services 
                    under the laws of India.
                </p>
                <p className="TermsConditions-points">
                    19. hi™ is free at its sole discretion to use any comments, information, ideas, concepts, 
                    reviews, or techniques or any other material contained in any communication you may send 
                    to us ("User Feedback"), including responses to questionnaires or through postings to the 
                    Application and user submissions, without further compensation, acknowledgement or payment 
                    to you for any purpose whatsoever including, but not limited to, developing, manufacturing 
                    and marketing products and creating, modifying or improving the service offering including 
                    Application. By posting / submitting any User Feedback / user content/ user submission on 
                    the Application, you grant the Company a perpetual, worldwide, non-exclusive, royalty-free 
                    irrevocable, sub-licensable license and right in such User Feedback /user content/ user 
                    submission to the Company, including the right to display, use, reproduce, or modify the 
                    User Feedback / user content/ user submission in any media, software or technology of any 
                    kind now existing or developed in the future. aiRender® Technology® Technology Pvt. Ltd. 
                    reserves the right to remove User Feedback / user content/ user submission at sole 
                    discretion and/or upon on request of any third party that such User Feedback / user 
                    content/ user submission may create liability for the Company or harm the reputation of 
                    Company or are offensive, inappropriate, defamatory, obscene or libelous in nature.
                </p>
                <p className="TermsConditions-points">
                    20. Third-Party Fees: You may incur access or data fees from third parties (such as your 
                    internet provider or mobile carrier) in connection with your use of Services and of 
                    Application. You are solely responsible for all such fees. In other words, the Company is 
                    not responsible for such fees, availability or non-availability of any third-party services and any corresponding loss of Services.
                </p>
                <p className="TermsConditions-points">
                    21. Updates: You may need to install updates to the Application or related software that 
                    we introduce from time to time to use of the Application. Services originating from the 
                    Application may communicate with the servers from time to time to check for available 
                    updates to the Services and to the functionality of the Application, such as bug fixes, 
                    patches, enhanced functions, missing plug-ins and new versions (collectively, "Updates"). 
                    Your use of the Services you have installed requires that you have agreed to receive such 
                    automatically requested Updates. The terms of this EULA will govern any Upgrades, updates, 
                    modifications or enhancements to the Application.
                </p>
                <p className="TermsConditions-points">
                    22. Where you download the Application on a device and from an application store of any 
                    specific operating system, you shall be obligated to adhere to all the terms and conditions 
                    of the use of such device, the terms and conditions of the relevant application store 
                    maintained by such operating system, in addition to this EULA. For avoidance of any doubt, 
                    the Company shall not be responsible for any losses arising out of or in connection with 
                    this EULA for any failures, acts or omissions by you of the Application to comply with the 
                    terms and conditions for the use of such device.
                </p>
                <p className="TermsConditions-points">
                    23. The Company or all the right holders in/of the Application and/or your smart 
                    phone/tablet/desktop, as the case may be, own title, interest and rights, including all 
                    related intellectual property rights, in/of the Application and/or your smart 
                    phone/tablet/desktop and the user acknowledges that such ownership shall include all 
                    intellectual property rights arising from any suggestions, enhancement requests, 
                    recommendations or other information provided by the user, whether in the course of use of 
                    the Application, your smart phone/tablet or otherwise.
                </p>
                <p className="TermsConditions-points">
                    24. Where any particular term or provision of this EULA is determined under applicable law 
                    to be un-enforceable, such un-enforceable term(s) shall be severed from and will not affect 
                    any other terms and conditions. The Company reserves the right to substitute any such 
                    un-enforceable term or provision with a suitable and enforceable provision at its sole 
                    discretion.
                </p>
                <p className="TermsConditions-points">
                    25. All disputes shall be governed under the laws of India and are subject to the 
                    jurisdiction of the Courts in Bangalore, Karnataka, India only.
                </p>
                <p className="TermsConditions-points">
                    26. Cancellation and Refund Policy
                    <p className="TermsConditions-sub-points-L1">
                        All purchases are final. We do not offer cancellations or refunds for any products/services 
                        purchased through our platform. Please review your order carefully before making a purchase.
                    </p>
                </p>
                <p className="TermsConditions-points">
                    27. If you have questions or concerns about this policy, please contact at 
                    airender@airender.in
                </p>
                <p className="TermsConditions-last-update">
                    Last Updated: 5th May, 2021. 
                    Copyright © 2021, aiRender® Technology Pvt Ltd. All rights reserved.
                </p>
            </div>
        </div>
    )
}

export default TermsConditions;